import { AuthenticationConfig, provideAuthentication } from 'sima-suite-authentication'

export { useAuthentication, type AuthenticationConfig } from 'sima-suite-authentication'

export const init = async (config: AuthenticationConfig) => {
  config.silentRenew = ''
  provideAuthentication(config)
}
